import {
  DEPARTURE_UA_BOOKINGS_LOADING,
  DEPARTURE_UA_BOOKINGS_FAILED,
  DEPARTURE_UA_BOOKINGS_SUCCESS,
  } from "../types"
  
  const initialState = {
    unassignedBookings: [],
    loading: false,
    error: false,
  }
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case DEPARTURE_UA_BOOKINGS_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          unassignedBookings: [],
        }
      case DEPARTURE_UA_BOOKINGS_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          unassignedBookings: [],
        }
      case DEPARTURE_UA_BOOKINGS_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          unassignedBookings: action.payload,
        }
      default:
        return state
    }
  }
  